// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
import App from './App'
import router from './router'
import store from './store'
import DateFilter from '@/common/date.filter'
import ShippingUuidFilter from '@/common/shippingUuid.filter'
import WhatsappizeFilter from '@/common/whatsappize.filter'
import CapitalizeFilter from '@/common/capitalize.filter'
import BrizeFilter from '@/common/brize.filter'
import CurrencyFilter from '@/common/currency.filter'
import PhoneFormatterFilter from '@/common/phoneFormatting.filter'
import ArrayToListFilter from '@/common/arrayToList.filter'
import BootstrapVue from 'bootstrap-vue'
import TitleMixin from '@/common/titleMixin'
Vue.mixin(TitleMixin)

import FetchesMixin from '@/mixins/fetches.mixin.js'
Vue.mixin(FetchesMixin)

import UtilsMixin from '@/mixins/utils.mixin'
Vue.mixin(UtilsMixin)

import ModelsMixin from '@/mixins/models.mixin'
Vue.mixin(ModelsMixin)

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faSignOutAlt, faBookmark, faTrashAlt, faPhone, faCheck, faArrowAltCircleLeft, faEdit, faMapMarker, faMapMarkerAlt, faShoppingBag, faMapMarkedAlt, faExclamationTriangle, faPencilAlt, faFilePdf, faStop, faPlay, faCloudRain, faComment, faTools, faPaperclip, faExchangeAlt, faLongArrowAltRight, faLongArrowAltLeft, faQrcode, faCrosshairs, faExternalLinkAlt, faKeyboard, faEnvelope, faLock, faUnlock, faInfoCircle, faList, faTh, faCog, faTv, faMoneyBillAlt, faGhost, faRedo, faPrint, faDownload
} from '@fortawesome/free-solid-svg-icons'
import { faBookmark as farBookmark, faClock, faCopy, faImage, faCalendarAlt, faEye, faEyeSlash, faTimesCircle } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import GetTextPlugin from 'vue-gettext'
import translations from './translations.json'
import appConfig from '@/config.js'
import * as moment from 'moment-timezone'
import momentDurationFormatSetup from 'moment-duration-format'
momentDurationFormatSetup(moment)

Vue.prototype.moment = moment
window.moment = moment

import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.prototype.$appConfig = appConfig

Vue.prototype.$roles = {
  COURIER: 'courier',
  COMPANY_ADMIN: 'company-admin',
  GCM_ADMIN: 'gcm-admin',
  SUPER_ADMIN: 'super-admin',
  OPERATOR: 'operator',
  OPERATOR_SUPERVISOR: 'operator-supervisor',
  HEAD_OPERATIONS: 'head-operations',
  HEAD_SALES: 'head-sales',
  COMMERCIAL: 'commercial',
  ACCOUNTANT: 'accountant',
  INTERNATIONAL: 'international',
  INTEGRATOR: 'integrator',
  WAREHOUSE: 'warehouse',
  WAREHOUSE_OPS: 'warehouse-ops',
  ACCOUNT_APPROVER: 'account-approver',
  ADMIN: 'admin',
  COURIER_ADMIN: 'courier-admin',
  ONBOARDING: 'onboarding',
  FLEET: 'fleet',
  FLEET_ADMIN: 'fleet-admin'
}

library.add(faUser, faSignOutAlt, faBookmark, faTrashAlt, faPhone, faCheck, faArrowAltCircleLeft, faEdit, faMapMarker, faMapMarkerAlt, faShoppingBag, faMapMarkedAlt, faExclamationTriangle, faPencilAlt, faFilePdf, faStop, faPlay, faCloudRain, faComment, faTools, faPaperclip, faExchangeAlt, faLongArrowAltRight, faLongArrowAltLeft, faQrcode, faCrosshairs, faExternalLinkAlt, faKeyboard, faEnvelope, faLock, faUnlock, faInfoCircle, faList, faTh, faCog, faTv, faMoneyBillAlt, faGhost, faRedo, faPrint, faDownload, farBookmark, faClock, faCopy, faImage, faCalendarAlt, faEye, faEyeSlash, faTimesCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

import UserCard from '@/components/UserCard'
Vue.component('user-card', UserCard)
import CompanyCard from '@/components/CompanyCard'
Vue.component('company-card', CompanyCard)

Vue.config.productionTip = true

Vue.filter('date', DateFilter)
Vue.filter('uuid', ShippingUuidFilter)
Vue.filter('whatsappize', WhatsappizeFilter)
Vue.filter('capitalize', CapitalizeFilter)
Vue.filter('brize', BrizeFilter)
Vue.filter('currency', CurrencyFilter)
Vue.filter('phone', PhoneFormatterFilter)
Vue.filter('arrayToList', ArrayToListFilter)

Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(VueCookies, {path: '/'})

// Vue.use(GetTextPlugin, {
//   translations: translations,
//   defaultLanguage: 'es_AR',
//   silent: true,
//   availableLanguages: {
//     en_US: 'English',
//     es_AR: 'Español de Argentina',
//     es_CO: 'Español de Colombia',
//     es_ES: 'Español de España',
//     pt_BR: 'Português do Brasil'
//   }
// })

import VueHtmlToPaper from 'vue-html-to-paper'

const options = {
  name: '_blank',
  specs: [
    'fullscreen=no',
    'titlebar=no',
    'scrollbars=no',
    'menubar=no',
    'location=no'
  ],
  styles: [
    'https://cdnjs.cloudflare.com/ajax/libs/bootstrap/4.6.2/css/bootstrap.min.css'
  ]
}

Vue.use(VueHtmlToPaper, options)

Vue.http.interceptors.push((req, next) => {
  // Add eco header if it's an API req and there is eid
  if (req.url.includes(appConfig.api.baseUrl) && window.localStorage.getItem('eid')) {
    // req.headers.set('X-Requested-With', window.localStorage.getItem('eid') + '')
    req.headers.set('x-moova-ecosystem-id', window.localStorage.getItem('eid') + '')
  }
})

Vue.http.interceptors.push((req, next) => {
  next(res => {
    let obj
    if (res.status > 401 && res.status <= 500) {
      console.log(this)
      let message = ''
      if (res.status === 422) {
        for (let i = 0; i < res.body.errors.length; i++) {
          message += '- ' + res.body.errors[i].detail + '<br>'
        }
      } else {
        message = res.body.message
      }
      obj = {
        title: 'ERROR',
        message: message,
        type: 'error'
      }
      console.log('%cStatus ' + res.status + '\n"' + obj.message + '" on:\n' + res.url, 'padding: 5px; background: #f00; color: #cf0;font-size: 1.5em; font-weight: bold;')
      moovaAdmin.$root.$children[0].$refs.simplert.openSimplert(obj)
    } else if (res.status === 0 && res.url.indexOf('couriers-summary') === -1) {
      obj = {
        title: 'ERROR',
        message: '<h1>SERVER error :/</h1>',
        type: 'error'
      }
      moovaAdmin.$root.$children[0].$refs.simplert.openSimplert(obj)
    }
  })
})

if (appConfig.debug !== true) {
  window.console.log = function () {}
}

// ApiService.init()

let moovaAdmin

function getCookie(name) {
  let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}

async function fetchEcosystem() {
  const hostname = window.location.hostname.replace('dashboard.', '').replace('backoffice.', '').replace('gcm2.', '').replace('gcm.', '')
  return await Vue.http.get(appConfig.api.baseUrl + 'ecosystems/by-hostname', { params: {hostname, fields: 'id,name,front_config,branding'} })
    .then(response => {
      Vue.prototype.$ecosystem = response.body
      Vue.prototype.$universe = response.body.front_config && response.body.front_config.universe ? response.body.front_config.universe : {
        siteName: 'Moova',
        logo: '/static/img/moova.svg',
        logoLogin: '/static/img/moova-blue.svg',
        theme: 'moova',
        helpUrl: 'http://ayuda.moova.io/',
        helpEmail: 'help@moova.io',
        salesEmail: 'comercial@moova.io',
        googleRegister: true,
        terms: 'https://moova.io/terminos-y-condiciones/',
        privacy: 'https://moova.io/politica-de-privacidad/'
      }
      store.dispatch('setUniverse', Vue.prototype.$universe)
      Vue.prototype.$eid = response.body.id
      store.dispatch('setEid', Vue.prototype.$eid)
      Vue.prototype.$ename = response.body.name
    }, e => {
      console.log(e)
      Vue.prototype.$universe = {
        siteName: 'Moova',
        logo: '/static/img/moova.svg',
        logoLogin: '/static/img/moova-blue.svg',
        theme: 'moova',
        helpUrl: 'http://ayuda.moova.io/',
        helpEmail: 'help@moova.io',
        salesEmail: 'comercial@moova.io',
        googleRegister: true,
        terms: 'https://moova.io/terminos-y-condiciones/',
        privacy: 'https://moova.io/politica-de-privacidad/'
      }
      store.dispatch('setUniverse', Vue.prototype.$universe)
      Vue.prototype.$eid = '1'
      store.dispatch('setEid', Vue.prototype.$eid)
      Vue.prototype.$ename = 'Moova'
    })
    .then(async () => {
      return await fetchCountries(Vue.prototype.$eid)
    })
}

// Get all active countries
async function fetchCountries(eid = 1) {
  const countryParams = {
    includes: [
      'notification_configs'
    ],
    filter_groups: [
      {
        filters: [
          ['ecosystem_id', 'eq', eid]
        ]
      }
    ]
  }
  return await Vue.http.get(appConfig.api.baseUrl + 'countries', { params: countryParams })
    .then(response => {
      window.countries = response.body.data
      if (Vue.prototype.$eid === 1) {
        let index = response.body.data.findIndex(x => x && x.front_config && x.front_config.universe && x.front_config.universe.domain === window.location.hostname)
        Vue.prototype.$frontConfig = index !== -1 ? window.countries[index].front_config : null
        if (Vue.prototype.$frontConfig && Vue.prototype.$frontConfig.universe && Vue.prototype.$frontConfig.universe.restrictRegisterToCountry) {
          if (!getCookie('country')) {
            document.cookie = 'country=' + window.countries[index].iso_code.toUpperCase() + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
            window.country = window.countries[index].iso_code.toUpperCase()
            document.cookie = 'phonePrefix=' + Vue.prototype.$frontConfig.i18n.phonePrefix + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
            window.phonePrefix = Vue.prototype.$frontConfig.i18n.phonePrefix
          }
        }
      } else {
        let index = 0
        Vue.prototype.$frontConfig = window.countries[index].front_config
        if (Vue.prototype.$frontConfig && Vue.prototype.$universe) {
          if (!getCookie('country')) {
            document.cookie = 'country=' + window.countries[index].iso_code.toUpperCase() + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
            window.country = window.countries[index].iso_code.toUpperCase()
            document.cookie = 'phonePrefix=' + Vue.prototype.$frontConfig.i18n.phonePrefix + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
            window.phonePrefix = Vue.prototype.$frontConfig.i18n.phonePrefix
          }
        }
      }
      return response
    })
}

// Get user country
Vue.http.get(appConfig.geo.check, {headers: { 'Authorization': 'Basic ' + window.btoa(appConfig.geo.account + ':' + appConfig.geo.key) }}).then(response => {
  if (!getCookie('country')) {
    document.cookie = 'country=' + response.body.country.iso_code.toUpperCase() + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
    window.country = response.body.country.iso_code.toUpperCase()
    document.cookie = 'phonePrefix=;path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
    window.phonePrefix = ''
  } else {
    window.country = getCookie('bypassCountry') ? null : (window.country || getCookie('country'))
  }
}).catch(e => { // On FAIL set AR as default
  if (!getCookie('country') && !getCookie('countryFailure')) {
    document.cookie = 'countryFailure=true;path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
    document.cookie = 'country=AR;path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
    document.cookie = 'phonePrefix=54;path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
    window.country = 'AR'
    window.phonePrefix = '54'
  } else {
    window.country = getCookie('bypassCountry') ? null : (window.country || getCookie('country'))
  }
}).then(() => {
  // Fetch the ecosystem and set all active countries
  fetchEcosystem()
    .then(response => {
      // recheck for intl. user
      window.country = getCookie('bypassCountry') ? null : (window.country || getCookie('country'))
      // Set country list
      window.countries = response.body.data
      // Set global frontend config
      let preFrontConfig = Vue.prototype.$frontConfig
      Vue.prototype.$universe = preFrontConfig ? preFrontConfig.universe || null : null
      if (preFrontConfig && preFrontConfig.universe && preFrontConfig.universe.restrictRegisterToCountry) {
        Vue.prototype.$frontConfig = preFrontConfig
      } else {
        Vue.prototype.$frontConfig = response.body.data.findIndex(x => x.iso_code === window.country) !== -1 ? response.body.data.find(x => x.iso_code === window.country).front_config : response.body.data[0].front_config
      }
      if (Vue.prototype.$frontConfig) {
        if (preFrontConfig && preFrontConfig.universe) {
          Vue.prototype.$universe = preFrontConfig.universe
        }
        // Set global TZ (fallback to UTC)
        Vue.prototype.$frontConfig.i18n.tz = Vue.prototype.$tz = getCookie('bypassCountry') || !Vue.prototype.$frontConfig.i18n.tz ? 'UTC' : Vue.prototype.$frontConfig.i18n.tz
      }

      // Set default GetTextPlugin
      Vue.use(GetTextPlugin, {
        translations: translations,
        defaultLanguage: 'es',
        silent: true,
        availableLanguages: {
          en: 'English',
          es: 'Español'
        }
      })

      window.phoneFormattersFile = require('../node_modules/cleave.js/dist/addons/cleave-phone.i18n.js')

      /* eslint-disable no-new */
      moovaAdmin = new Vue({
        el: '#app',
        router,
        store,
        template: '<App/>',
        components: { App }
      })
      window.moovaAdmin = moovaAdmin
    })
})
